<div class="score">
  <div class="gained" [style.width.%]='gainedP()'></div>
  <div class="pending" [style.width.%]='pendingP()'></div>
  <div class="lost" [style.width.%]='lostP()'></div>
  <div *ngIf="hasMastery()" class="mastery" [style.left.%]='masteryP()'></div>
</div>
